import React, { Component } from 'react';
import { Switch, Route } from 'react-router-dom';
import { validateWorkload, saveworkloadopened, redirectPage, toggleSizeButton, SaveCurrentSession, addSession, changeSession, deleteSession, updateSession, errorValidataion, getSolution, getAdvancedSolution, saveWorkload, showLoading } from '../../State/actions/sessions';
import { connect } from 'react-redux';
import Box from 'grommet/components/Box';
import Split from 'grommet/components/Split';
import Button from 'grommet/components/Button';
//import List from 'grommet/components/List';
import Heading from 'grommet/components/Heading';
//import ListItem from 'grommet/components/ListItem';
import Layer from 'grommet/components/Layer';
//import RadioButton from 'grommet/components/RadioButton';
import Menu from 'grommet/components/Menu';
import ReactTooltip from 'react-tooltip';
import Anchor from 'grommet/components/Anchor';
import Animate from 'grommet/components/Animate';
import Paragraph from 'grommet/components/Paragraph';
import TextInput from 'grommet/components/TextInput';
import Status from 'grommet/components/icons/Status';
import FormArrow from 'grommet/components/icons/base/FormNextLink';
//import Toast from 'grommet/components/Toast';
import Home from 'grommet/components/icons/base/Home';
import Revert from 'grommet/components/icons/base/Revert';
import User from 'grommet/components/icons/base/User';
import UserAdd from 'grommet/components/icons/base/UserAdd';
import TrashIcon from 'grommet/components/icons/base/FormTrash';
import ContractIcon from 'grommet/components/icons/base/Contract';
import CloseIcon from 'grommet/components/icons/base/Close';
import SaveIcon from 'grommet/components/icons/base/Save';
import CaretNext from 'grommet/components/icons/base/CaretNext';
import Magic from 'grommet/components/icons/base/Services';
import CaretPrevious from 'grommet/components/icons/base/CaretPrevious';
import CircleInformation from 'grommet/components/icons/base/CircleInformation';
import FormNextLink from 'grommet/components/icons/base/FormNextLink';
import FormEdit from 'grommet/components/icons/base/FormEdit';
//import FormClose from 'grommet/components/icons/base/FormClose';
import MenuIcon from 'grommet/components/icons/base/Menu';
import WarningIcon from 'grommet/components/icons/base/Alert';
import Table from 'grommet/components/Table';
import TableRow from 'grommet/components/TableRow';
//import Select from 'grommet/components/Select';
//import Label from 'grommet/components/Label';
import CustomFooter from './CustomFooter';

import SolnAlternative from './SolnAlternative';
//import {version,said,sizerType,sizerName,launcher,launcherClass} from '../../AppConfig';
import { said, serviceUrl, appUrl, title } from '../../AppConfig';
import $ from 'jquery';

import { interviewScreens } from '../../SizerScreens';
import SolutionPreview from './SolutionPreview';
import {redirectToSSET,clearSSETDataAndRedirect} from './Utils';
import * as commonConstants from '../../State/constants/CommonConstants';
import DocumentConfig from 'grommet/components/icons/base/DocumentConfig';
import LoadFiles from './LoadFiles';

var NextBtnVisible = true;
var fromsoln = false;
const HPECP_SIZER = ('EzmeralCPSizer').toUpperCase();
const EPA_SIZING = 'EPASizing';

function CreateGuid() {
  function _p8(s) {
    var p = (Math.random().toString(16) + "000000000").substr(2, 8);
    return s ? "-" + p.substr(0, 4) + "-" + p.substr(4, 4) : p;
  }
  return _p8().toUpperCase() + _p8().toUpperCase() + _p8().toUpperCase() + _p8().toUpperCase();
}

class Build extends Component {

  constructor() {
    super();
    this.state = {
      ShowRightLayer: false,
      showFooter: true,
      ShowProgressBar: false,
      showAddSession: false,
      showUpdateSession: false,
      showDelSession: false,
      showSaveWorkload: false,
      SessionName: {},
      SessionNameTxt: '',
      activeSession: 0,
      DelSession: '',
      ToggleMinimize: false,
      RouteObj: [],
      ErrorPopup: false,
      ErrorPopupMsg: '',
      RedirectPopup: false,
      RedirectMsg: '',
      showDupWLPopup: false,
      DupAvailable: '',
      TitleofSizer: '',
      isTryingToNavigate: false,
      sizingFailed: false,
      sizingFailedMsg: '',
      typeChoice: '',
      bigdataChecked: true,
      bluedataChecked: false,
      showRedirectConfirm: false,
      LoadItemTitle: '',
      LoadPopupScr: false,

    }
    this.goHome = this.goHome.bind(this);
    this.onPrevClick = this.onPrevClick.bind(this);
    this.onNextClick = this.onNextClick.bind(this);
    this.onFinish = this.onFinish.bind(this);
    // this.SetTimeoutFinish = this.SetTimeoutFinish.bind(this);
    this.RightNavLayer = this.RightNavLayer.bind(this);
    this.NextBtnVisible = this.NextBtnVisible.bind(this);
    this.ShowDelSession = this.ShowDelSession.bind(this);
    this.CloseDelSession = this.CloseDelSession.bind(this);
    this.SessionTxtChange = this.SessionTxtChange.bind(this);
    this.SaveWorkloadSubmit = this.SaveWorkloadSubmit.bind(this);
    this.onSaveWorkloadIconClick = this.onSaveWorkloadIconClick.bind(this);
    this.SaveWorkload = this.SaveWorkload.bind(this);
    this.AddUserClick = this.AddUserClick.bind(this);
    this.Submit_Add_Session = this.Submit_Add_Session.bind(this);
    this.Submit_Update_Session = this.Submit_Update_Session.bind(this);
    this.Submit_Change_Session = this.Submit_Change_Session.bind(this);
    this.Submit_Delete_Session = this.Submit_Delete_Session.bind(this);
    this.ToggleMinimize = this.ToggleMinimize.bind(this);
    this.onSolnLostPopupYes = this.onSolnLostPopupYes.bind(this);
    this.onSolnLostPopupClose = this.onSolnLostPopupClose.bind(this);

    this.OverrideMsgYesClick = this.OverrideMsgYesClick.bind(this);
    this.OverrideMsgNoClick = this.OverrideMsgNoClick.bind(this);
    this.onBackButtonEvent = this.onBackButtonEvent.bind(this);
    this.pushNext = this.pushNext.bind(this);
    this.pushBack = this.pushBack.bind(this);
    this.sizeFailedClose = this.sizeFailedClose.bind(this);
    this.isModified = this.isModified.bind(this);
    this._handleOnPaste = this._handleOnPaste.bind(this);
    this.goBackToSSET = this.goBackToSSET.bind(this);
    this.updateTitle = this.updateTitle.bind(this);
    this.LoadWorkloadPopupClick = this.LoadWorkloadPopupClick.bind(this);
    this.getNewRoute = this.getNewRoute.bind(this);
    this.closePopUps = this.closePopUps.bind(this);
  }

  componentWillMount() {
    this.state.RouteObj = interviewScreens;
    // window.onpopstate = function (e) { window.history.forward(1); }
  }

  _handleOnPaste(e) {
    e.preventDefault();
  }

  onBackButtonEvent(e) {

    e.preventDefault();
    window.history.forward();
  }

  // goBackToSSET() {    
  //     fetch(serviceUrl+'API/ExternalSizing/GetSSETUrl', {
  //       method: "GET",
  //       headers: {
  //         'Accept': 'application/json',
  //         'Content-Type': 'application/json',
  //         'Cache': 'no-cache'
  //       },
  //       credentials: 'same-origin'
  //     })
  //       .then((response) => {window.location.replace(response)})
  //       .then(console.log('Error'));    
  // }
  goBackToSSET()
  {
    this.setState({showRedirectConfirm:true});
  }
  goBackToSSETno()
  {
    this.setState({showRedirectConfirm:false});
  }
  
  goBackToSSETyes() {     
    let id = this.props.activeSession.alias.split("#")[1];    
    let isReviewed = this.props.sessionsData.reviewed;
    if (!isReviewed) {       
      this.setState({showRedirectConfirm:false});
      this.props.onShowLoading();
      clearSSETDataAndRedirect(this.props.UserID,id,isReviewed);
    } else {      
      redirectToSSET(id,isReviewed);
    }
  }
  updateTitle(e) {
    var mode = '';
    var title = '';//this.props.TitleCaption["SizerCaption"];  
    if (e === undefined)
      this.props.sizerWorkLoad !== undefined && this.props.sizerWorkLoad !== '' ? mode = this.props.sizerWorkLoad.Workload.UserInputs.SizerMode : mode = undefined;
    else
      mode = e;
    switch (mode) {
      //case 'CS750Sizing': title = this.props.TitleCaption["SizerCaption"]; break;
      // case 'CS750Sizing': title = 'HPE Sizer for ConvergedSystems Virtualization'; break;
      case 'CS750Sizing': title = this.props.SSETid === undefined ? 'HPE Sizer for ConvergedSystems Virtualization' : 'HPE CS750/CA750 SY Gen10 for Virtualization'; break; 
      case 'SynergySizing': title = 'VMware ESXi on HPE Platform'; break;
      case 'vSANSizing': title = this.props.sizerWorkLoad.Workload.UserInputs.ConfigureVMwareCloudFoundation==='True'?'VCF on HPE Platform':'vSAN on HPE Platform'; break;
      case 'VDISizing': title = 'VDI on HPE Platform'; break;
      case 'BareMetalSizing': title ='Bare Metal on HPE Rack (DL) Servers'; break;
      case 'OCPSizing': title = /* Advance Sizing Inputs for  */'Red Hat OpenShift on HPE Synergy'; break; // added by aditya to display header for OCPSizing mode
      case EPA_SIZING : title = 'HPE Elastic Platform for Big Data Analytics (EPA)'; break;
      case HPECP_SIZER : title = this.props.SSETid && this.props.sizerWorkLoad.UserInputs.Environments.SSETMode ===commonConstants.SSETSizingModes.epaMLOps ?commonConstants.SSETTitles.epaMLOps:commonConstants.SSETTitles.hpeCP; break;
      
    }
    if (this.state.TitleofSizer === '' ||  this.state.TitleofSizer !== title)
      this.setState({ TitleofSizer: title });
  }

  componentDidMount() {
    
    if (appUrl.toUpperCase().indexOf(HPECP_SIZER) > -1) {
      this.setState({
        bigdataChecked : false,
        blueDataworkloadTemplate : true
      })
    } else {
      this.setState({
        bigdataChecked : true,
        bluedataChecked : false
      })
    }
    if (this.props.TitleCaption !== undefined && this.props.TitleCaption["SizerCaption"] !== undefined && this.props.TitleCaption["SizerCaption"] !== '') {
      if (said === 'CS750VirtSizer' ||  said === 'SynergySizer') {
        this.updateTitle();
      } else {
        this.setState({ TitleofSizer: this.props.TitleCaption["SizerCaption"] });
      }
    }
    window.onpopstate = this.onBackButtonEvent;
    fromsoln = false;
    if(said === 'SAPHANA' && !this.props.sizerWorkLoad.UserInputs.Environments.WorkloadType){
      this.props.sizerWorkLoad.UserInputs.Environments.WorkloadType = 'SAPHANA';
    }
    //Update route object
    var specificPages = interviewScreens.filter((route, id) => {
      if (route.type === undefined)
        return route;
      else {
        if (said === 'EPAvNext'||said === 'SAPHANA') {
          if(!(route.label=== commonConstants.GROWTH && this.props.sizerWorkLoad.UserInputs.GROWTHSCREEN==='False')){
            if (route.type === this.props.sizerWorkLoad.UserInputs.Environments.WorkloadType) {
              return route;
            }
          }
        }
      }
    });

    if (said === 'CS750VirtSizer' ||  said === 'SynergySizer') {
      let temp = [];
      if (this.props.sizerWorkLoad !== undefined && this.props.sizerWorkLoad.Workload.UserInputs.WorkloadInputMode === 'Simple') {
        temp.push(interviewScreens[0]);
        this.setState({ RouteObj: temp })

        if (!this.props.activeSession.globalError.isError) {
          this.props.OnToggleSizeButton(true);
        }
        else { this.props.OnToggleSizeButton(false); }
        this.props.history.push(temp[0].path);
      }
      else {
        this.setState({ RouteObj: interviewScreens });
        this.props.history.push(interviewScreens[0].path);
        this.props.OnToggleSizeButton(false);
      }
    }

    else {
      this.setState({ RouteObj: specificPages });
      this.props.history.push(specificPages[0].path);
    }
  }

  componentWillReceiveProps(nextProps, nextState) {
    if (said === 'CS750VirtSizer' ||  said === 'SynergySizer') {
      if (nextProps.sizerWorkLoad !== undefined && this.props.sizerWorkLoad !== undefined) {
        this.updateTitle(nextProps.sizerWorkLoad.Workload.UserInputs.SizerMode);
      }

      if (this.props.sizerWorkLoad !== undefined) {
        if (nextProps.sizerWorkLoad.Workload.UserInputs.WorkloadInputMode !== this.props.sizerWorkLoad.Workload.UserInputs.WorkloadInputMode) {
          let temp = [];
          if (nextProps.sizerWorkLoad.Workload.UserInputs.WorkloadInputMode === 'Simple') {
            temp.push(interviewScreens[0]);
            this.setState({ RouteObj: temp })
            if (!nextProps.activeSession.globalError.isError) {
              this.props.OnToggleSizeButton(true);
            }
            else { this.props.OnToggleSizeButton(false); }
          }
          else {
            this.setState({ RouteObj: interviewScreens });
            this.props.OnToggleSizeButton(false);
          }
        }
      }
      // else if( nextProps.sizerWorkLoad!==undefined && this.props.sizerWorkLoad!== undefined && this.props.sizerWorkLoad.Workload.UserInputs.SizerMode !== nextProps.sizerWorkLoad.Workload.UserInputs.SizerMode)
      // {
      //   this.updateTitle(nextProps.sizerWorkLoad.Workload.UserInputs.SizerMode);
      // }
    }

    if (said === 'EPAvNext' && this.props.SSETid !== undefined ) {
      if (nextProps.sizerWorkLoad !== undefined && this.props.sizerWorkLoad !== undefined) {
        if (appUrl.toUpperCase().indexOf(HPECP_SIZER) > -1 ) {
          this.updateTitle(HPECP_SIZER);
        } else {
          this.updateTitle(EPA_SIZING);
        }
      }
    }

    if (nextProps.SSETUrl !== undefined) {
      window.location.replace(nextProps.SSETUrl);
    }

    if (nextProps.activeSession.sizingFailed !== undefined && nextProps.activeSession.sizingFailed.isFailed) {
      if (nextProps.activeSession.sizingFailed.isFailed) {
        this.setState({ sizingFailed: true, sizingFailedMsg: nextProps.activeSession.sizingFailed.Exception });
      }
    }


    if (this.state.isTryingToNavigate && this.props.validation.required) {
      if (nextProps.activeSession.globalError.isError) {
        this.setState({ ErrorPopup: true, ErrorPopupMsg: nextProps.activeSession.globalError.errorMsg, isTryingToNavigate: false });
        return;
      }
      else {
        this.setState({ isTryingToNavigate: false });
        this.pushNext();
        return;
      }
    }



    if (nextProps.activeSession.id === '') {
      if (nextProps.allSessions.length > 0) {
        this.props.onChangeSession(nextProps.allSessions[0].id);
        this.props.onNewSession(nextProps.allSessions[0].workload);
        if (said === 'EPAvNext') {
          this.props.indexes.functions = 0;
          this.props.indexes.extraConfiguration = 0;
          let specificPages = interviewScreens.filter((route, id) => {
            if (said === 'EPAvNext') {
              if (route.type === nextProps.allSessions[0].workload.UserInputs.Environments.WorkloadType) {
                return route;
              }
            }
          });

          this.setState({ RouteObj: specificPages });
          this.props.history.push(specificPages[0].path);
        }
        else {
          this.props.history.push(this.state.RouteObj[0]['path'])
        }
        $('#footer').hide()
      }
      else {

        if (said === 'EPAvNext') {
          this.props.indexes.functions = 0;
          this.props.indexes.extraConfiguration = 0;
          if (this.props.sizerWorkLoad.UserInputs.Environments.WorkloadType === 'BigData') {
            this.props.onNewSession(this.props.workloadTemplate);
          }
          else {
            this.props.onNewSession(this.props.blueDataworkloadTemplate);
          }
        }
        else {
          this.props.onNewSession(this.props.workloadTemplate);
        }
        this.props.history.push('/Home');
        $('#footer').show()
      }
    }
    else {
      $('#footer').hide()
      if (nextProps.activeSession.treeView !== '' && !fromsoln) {
        if (!window.location.pathname.match("/SolnAlternative")) {
          this.props.history.push('/Build/SolnAlternative');
          $('#footer').show()
        }
      } else if (window.location.pathname.match("/SolnAlternative") && !fromsoln) {
        this.props.history.push(this.state.RouteObj[0]['path']);
        $('#footer').hide()
      }
      else {

        if (nextProps.OverrideMsg.isEnabled) {
          this.state.showDupWLPopup = true;
          this.state.showSaveWorkload = true;
        } else {
          // this.state.showSaveWorkload = false;
          this.state.showDupWLPopup = false;
        }

        if (nextProps.toastNotification.isEnabled) {
          this.state.showSaveWorkload = false;
        }
      }
    }

    if (nextProps.Redirect.isEnabled) {
      this.props.history.push(nextProps.Redirect.path);
      this.props.onRedirectPage(false, '');
    }


    if (nextProps.activeSession.id !== "" && this.props.activeSession.id !== nextProps.activeSession.id) {
      let specificPages = interviewScreens.filter((route, id) => {
        if (route.type === undefined)
          return route;
        else {
          if (said === 'EPAvNext' || said === 'SAPHANA') {
            if (said === 'EPAvNext'){
            this.props.indexes.functions = 0;
            this.props.indexes.extraConfiguration = 0;
            }
            if (route.type === nextProps.sizerWorkLoad.UserInputs.Environments.WorkloadType) {
              return route;
            }
          }
        }
      });

      if (said === 'CS750VirtSizer' ||  said === 'SynergySizer') {
        var temp = [];
        if (nextProps.sizerWorkLoad !== undefined && nextProps.sizerWorkLoad.Workload.UserInputs.WorkloadInputMode === 'Simple') {
          temp.push(interviewScreens[0]);
          this.setState({ RouteObj: temp })

          if (!this.props.activeSession.globalError.isError) {
            this.props.OnToggleSizeButton(true);
          }
          else { this.props.OnToggleSizeButton(false); }
          this.props.history.push(temp[0].path);
        }
        else {
          this.setState({ RouteObj: interviewScreens });
          this.props.history.push(interviewScreens[0].path);
          this.props.OnToggleSizeButton(false);
        }
      }

      else {

        this.setState({ RouteObj: specificPages });
        this.props.history.push(specificPages[0].path);
      }
    }
  }
  onSolnLostPopupYes(selLabel) {
    this.state.RouteObj.map((route, id) => {
      if (route.label === selLabel) {
        this.props.history.push(route.path);
        // new addition
        fromsoln = true;
        // this.props.activeSession.isSizeEnabled = false;
        // this.props.activeSession.treeView = '';
        // this.props.activeSession.bomView = '';
        // this.props.activeSession.configView = '';
        // this.props.activeSession.GRInput = '';
        // this.props.activeSession.GRBomInput = '';
      }
    });
    this.props.onSaveCurrentSession();
    this.setState({ ShowSolnLostMsg: false, NavSelection: '' });
  }

  onSolnLostPopupClose() {
    this.setState({ ShowSolnLostMsg: false, NavSelection: '' });
  }

  isModified() {
    var savedWl = this.props.allSessions.filter((item) => {
      if (item.id === this.props.activeSession.id) {
        return item;
      }
    });
    if (savedWl.length > 0) {
      if (JSON.stringify(this.props.sizerWorkLoad) === JSON.stringify(savedWl[0].workload))
        return false;
      else if (this.props.sizerWorkLoad !== undefined && JSON.stringify(this.props.sizerWorkLoad.Workload) === JSON.stringify(savedWl[0].workload))
        return false;
      else return true;
    }
    else return true;
  }

  onSolutionSummaryclick() {
    if (this.props.GlobalErr !== '' && this.props.GlobalErr.isError) {
      this.setState({ ErrorPopup: true, ErrorPopupMsg: this.props.GlobalErr.errorMsg });
    } else if (this.props.activeSession.isSizeEnabled) {

      if (!this.isModified()) {
        fromsoln = false;
        if (said === 'EPAvNext') {
          this.setState({ ShowRightLayer: false });
        }
        this.props.history.push('/Build/SolnAlternative');
      }
      else {
        this.props.activeSession.treeView = '';
        this.onFinish();
      }
    } else if (!this.isModified()) {
      fromsoln = false;

      if (said === 'EPAvNext') {
        this.setState({ ShowRightLayer: false });
      }

      this.props.history.push('/Build/SolnAlternative');
    }
    else {
      this.setState({ sizingFailed: true, sizingFailedMsg: "Workload inputs has been Modified.  Please Navigate to next page and re-size." });
    }

  }

  onLeftNavSelection(e) {
    $('#footer').hide()
    // console.log(e.target.id);
    if (this.props.GlobalErr !== '' && this.props.GlobalErr.isError) {
      this.setState({ ErrorPopup: true, ErrorPopupMsg: this.props.GlobalErr.errorMsg });
    } else {
      if (window.location.pathname.match('/Build/SolnAlternative')) {
        //Show Solution will be lost msg
        this.onSolnLostPopupYes(e.target.id);
        //this.setState({ShowSolnLostMsg: true, NavSelection: e.target.id });
      } else {
        // if(this.props.activeSession.workload.UserInputs.Environments.ProductionEnvironment.ProcessorSelected === 'Select Processor'){
        //   this.setState({ErrorPopup: true, ErrorPopupMsg: 'Please select the processor from the dropdown.' });
        //   this.props.history.push('/Build/EnvironmentDetails');
        // }else{
        this.state.RouteObj.map((route, id) => {
          if (route.label === e.target.id) {
            this.props.history.push(route.path);
           // this.props.history.push(route.id);
            // if( !window.location.pathname.match('/Build/SolnAlternative') ){
            //   this.props.activeSession.treeView = '';
            // }
          }
        });
        // }
      }
    }
    if(this.state.ShowRightLayer)
        this.setState({ ShowRightLayer: false })
  }

  onPrevClick() {
    if (!this.props.GlobalErr.isError && this.props.validation !== undefined && this.props.validation.required) {
      this.setState({ isTryingToNavigate: true });
      this.props.onValidateWorkload(this.props.validation.url, this.props.sizerWorkLoad);
    }
    else {
      this.pushBack();
    }

    if(this.state.ShowRightLayer)
        this.setState({ ShowRightLayer: false })
  }

  pushNext() {
    var index;
    this.state.RouteObj.map((route, id) => {
    	if (window.location.pathname.match(route.path)) {
          index = id;
        }
    });
    // if(this.state.RouteObj[index+1].isenabled){
    //   this.props.history.push(this.state.RouteObj[index+1].path);
    // }

    if (this.props.GlobalErr !== '' && this.props.GlobalErr.isError) {
      this.setState({ ErrorPopup: true, ErrorPopupMsg: this.props.GlobalErr.errorMsg });
    } else {
      this.props.history.push(this.state.RouteObj[index + 1].path);
    }
  }


  pushBack() {
    var index;
    this.state.RouteObj.map((route, id) => {
        if (window.location.pathname.match(route.path)) {
          index = id;
        }
    });
    // this.props.history.push(this.state.RouteObj[index-1].path);

    if (this.props.GlobalErr !== '' && this.props.GlobalErr.isError) {
      this.setState({ ErrorPopup: true, ErrorPopupMsg: this.props.GlobalErr.errorMsg });
    } else {
      this.props.history.push(this.state.RouteObj[index - 1].path);
    }
  }

  onNextClick() {

    if (!this.props.GlobalErr.isError && this.props.validation !== undefined && this.props.validation.required) {
      this.setState({ isTryingToNavigate: true });
      this.props.onValidateWorkload(this.props.validation.url, this.props.sizerWorkLoad);
    }
    else {
      this.pushNext();
    }
    if(this.state.ShowRightLayer)
        this.setState({ ShowRightLayer: false })
  }

  goHome() {
    // this.props.history.push('/Home');
    if (this.props.GlobalErr !== '' && this.props.GlobalErr.isError) {
      this.setState({ ErrorPopup: true, ErrorPopupMsg: this.props.GlobalErr.errorMsg });
    } else {
      if (said === 'EPAvNext') {
        this.props.indexes.functions = 0;
        this.props.indexes.extraConfiguration = 0;
      }
      this.props.onUpdateActiveSession(this.props.sizerWorkLoad);
      this.props.onSaveCurrentSession();
      this.props.history.push('/Home');
      $('#footer').show()
    }
  }

  // SetTimeoutFinish(){
  //   this.setState({showFooter: false, ShowProgressBar:false, ShowRightLayer:false})
  //   clearInterval(xx);
  //   this.props.history.push('/Build/SolnAlternative');
  // }

  onFinish() {
    // this.setState({ShowProgressBar: false});
    // xx = setInterval( this.SetTimeoutFinish, 3000);
	var obj;
    if (this.props.activeSession.id !== this.props.SSETid && this.props.SSETid === undefined) {
      fromsoln = false;

      this.props.activeSession.treeView = '';
      this.props.activeSession.bomView = '';
      this.props.activeSession.configView = '';
      this.props.activeSession.GRInput = '';
      this.props.activeSession.GRBomInput = '';

      this.state.ShowProgressBar = false;
      let workload = {
        "WorkLoad": {}
      };
      this.props.activeSession.workload = JSON.parse(JSON.stringify(this.props.sizerWorkLoad));
      workload.WorkLoad = this.props.activeSession.workload;
      var userId = this.props.UserID;
      var userName = this.props.UserName;
      if (userId === undefined) {
        userId = 'TestUser@test.com';
        userName = 'TestUSer';


      }
      obj = {
        "Workload": workload,
        "SessionID": this.props.activeSession.id,
        "UserId": userId,
        "SizerId": said,
        "Country": this.props.country,
        "UserName": userName
      }
      //}
      // obj.data.workload.WorkLoad = this.props.activeSession.workload;
      // var x = JSON.stringify(obj).replace('"','\"');TitleCaption

      //if (this.props.DefaultInputs['@name'] === "SAP Sizing Tool") {
      if (this.props.TitleCaption.Sizer['@name'] === "SAP Sizing Tool") {
        //  var ProdEnv = this.props.activeSession.workload.UserInputs.Environments.ProductionEnvironment;
        let ProdEnv = this.props.sizerWorkLoad.UserInputs.Environments.ProductionEnvironment;
        if (ProdEnv['SelectedProdDBServerOS'] === null) {
          this.setState({ ShowRightLayer: false, RedirectPopup: true, RedirectMsg: 'Sizing is not allowed. \nPlease check your configuration .' });
          return;
        }
      }


      if (this.props.TitleCaption.Sizer['@name'] === 'SAP HANA Sizing Tool') {
        //  var ProdEnv = this.props.activeSession.workload.UserInputs.Environments.ProductionEnvironment;
        let ProdEnv = this.props.sizerWorkLoad.UserInputs.Environments.ProductionEnvironment;
        if (ProdEnv['ProcessorSelected'] === 'Select Processor') {
          this.setState({ RedirectPopup: true, RedirectMsg: 'Sizing is not allowed. \nPlease check your configuration .', ShowRightLayer: false });
          return;
        }
      }
      if (said === 'CS750VirtSizer' ||  said === 'SynergySizer') {
        if (this.props.GlobalErr !== '' && this.props.GlobalErr.isError) {
          this.setState({ ErrorPopup: true, ErrorPopupMsg: this.props.GlobalErr.errorMsg });
        } else {
          this.props.OnToggleSizeButton(false);
          obj.Workload = obj.Workload.WorkLoad;
          this.props.onGetSolution(obj);
        }
      }
      else {
        if (this.props.GlobalErr !== '' && this.props.GlobalErr.isError) {
          this.setState({ ErrorPopup: true, ErrorPopupMsg: this.props.GlobalErr.errorMsg });
        } else {
          this.props.OnToggleSizeButton(false);
          this.props.onGetSolution(obj);
        }
      }

      if (said === 'EPAvNext') {
         this.props.ClearCompareData(false);
        this.setState({ ShowRightLayer: false })
      }
      if (said === 'SAPHANA' || said === 'SAP') {
        this.setState({ ShowRightLayer: false })
      }
    } else {


      let workload = {
        "WorkLoad": {}
      };
      this.props.activeSession.workload = JSON.parse(JSON.stringify(this.props.sizerWorkLoad));
      workload.WorkLoad = this.props.activeSession.workload;
      obj = {
        "Workload": workload,
        "ReferenceId": this.props.SSETid === undefined ? this.props.activeSession.id : this.props.SSETid,
        "isSizerAsEntry":false,
        "uInfo":this.props.sessionsData.uInfo
      }
      let expertSizingModes = ['CS750VirtSizer','SynergySizer',"EPAvNext",'SAPHANA','SAP'];
      if (expertSizingModes.indexOf(said)!==-1) {
        if (this.props.GlobalErr !== '' && this.props.GlobalErr.isError) {
          this.setState({ ErrorPopup: true, ErrorPopupMsg: this.props.GlobalErr.errorMsg });
        } else {
          this.props.OnToggleSizeButton(false);      
          if(said === 'CS750VirtSizer')
          {
          obj.Workload = obj.Workload.WorkLoad;
          obj.Workload.Workload.UserInputs.isSized = 'True';
          this.props.onGetAdvancedSolution(obj);
          }else {
            obj.Workload.WorkLoad.strSizerName = (()=>{
              let epaSizer = "EPA vNext Sizing Tool";
              let sapSizer = "SAP Sizing Tool";
              let hanaSizer = "SAP HANA Sizing Tool";        

              if(  said===commonConstants.SizerIds.EPAVNEXT) return epaSizer;
              else if (  said===commonConstants.SizerIds.SAP) return sapSizer;
              else return hanaSizer;
            })();            
            this.props.onGetAdvancedSolution(obj);
          }
        }
      }
    }
  }
  ShowDelSession(delItem) {
    this.setState({ showDelSession: true, DelSession: delItem });
  }

  CloseDelSession() {
    this.setState({ DupAvailable: '', SessionNameTxt: '', showSaveWorkload: false, showDelSession: false, showAddSession: false, SessionName: {}, DelSession: '', showUpdateSession: false });
    this.props.onDisableconflicts();
    this.props.OpenedSaveWorkload(false)
  }

  Submit_Delete_Session(SessionID) {
    if (this.props.GlobalErr !== '' && this.props.GlobalErr.isError) {
      this.setState({ ErrorPopup: true, ErrorPopupMsg: this.props.GlobalErr.errorMsg });
    } else {

      this.props.onDeleteSession(SessionID);

      this.CloseDelSession();
    }
  }

  Submit_Change_Session(SessionID) {


    if (this.props.GlobalErr != '' && this.props.GlobalErr.isError) {
      this.setState({ ErrorPopup: true, ErrorPopupMsg: this.props.GlobalErr.errorMsg });
    } else {
      if (this.props.activeSession.id !== SessionID) {

        var errorObj = { isError: false, errorMsg: '' };
        this.props.updateError(errorObj);
        this.props.onUpdateActiveSession(this.props.sizerWorkLoad);
        this.props.onSaveCurrentSession();

        this.props.onChangeSession(SessionID);
        var workload = '';
        this.props.allSessions.map((value, index) => {
          if (value.id === SessionID)
            workload = value.workload;
        })

        this.props.onNewSession(workload);
        // if(this.props.activeSession.treeView !== ''){
        //   this.props.history.push('/Build/SolnAlternative');
        // }else{
        //   this.props.history.push(this.state.RouteObj[0]['path']);
        // }
        fromsoln = false;
      }
    }
    if(this.state.ShowRightLayer)
    this.setState({ ShowRightLayer: false }) 
  }

  AddUserClick() {
    if (this.props.GlobalErr != '' && this.props.GlobalErr.isError) {
      this.setState({ ErrorPopup: true, ErrorPopupMsg: this.props.GlobalErr.errorMsg });
    } else {
      this.props.OpenedSaveWorkload(true)
      this.setState({ showAddSession: true, showUpdateSession: false, SessionNameTxt: '' });
    }
  }

  Submit_Add_Session() {
    if (this.state.SessionNameTxt.trim() !== '') {
      this.state.SessionName.alias = this.state.SessionNameTxt;
      this.props.onUpdateActiveSession(this.props.sizerWorkLoad);
      this.props.onSaveCurrentSession();
      if (said === 'CS750VirtSizer' ||  said === 'SynergySizer') {
        var obj = { "Workload": this.props.workloadTemplate }
        this.props.onNewSession(obj);
      }
      else if (said === 'EPAvNext') {
        this.state.bigdataChecked ? this.props.onNewSession(this.props.workloadTemplate) : this.props.onNewSession(this.props.blueDataworkloadTemplate)
        this.props.OpenedSaveWorkload(false)
      } else if(said === 'SAPHANA'){
        if(this.props.sizerWorkLoad.UserInputs.Environments.WorkloadType === 'TDI' ){
          this.props.onNewSession(this.props.tdiWorkloadTemplate);
        }
       else{
        this.props.onNewSession(this.props.workloadTemplate);
      }
    }
      else {
        this.props.onNewSession(this.props.workloadTemplate);
      }
      this.props.onAddSession(CreateGuid(), this.state.SessionName.alias);
      fromsoln = false;
      this.props.history.push(this.state.RouteObj[0]['path']);
      this.setState({ showAddSession: false, showUpdateSession: false, showDelSession: false, SessionName: {}, DelSession: '', ShowRightLayer:false });
    }
  }

  Submit_Update_Session() {
    if (this.state.SessionNameTxt.trim() !== '') {
      this.state.SessionName.alias = this.state.SessionNameTxt;
      this.props.onUpdateActiveSession(this.props.sizerWorkLoad);
      this.props.onSaveCurrentSession();
      this.props.onUpdateSession(this.state.SessionName);
      if (this.props.activeSession.id === this.state.SessionName.id) {
        this.props.onChangeSession(this.props.activeSession.id);
      }
      this.setState({ showDelSession: false, showAddSession: false, showUpdateSession: false, DelSession: '',ShowRightLayer:false });
    }
  }

  SessionTxtChange(e) {
    var duplicate = false;
    this.props.allSessions.filter((sessItem, index) => {

      if (sessItem.alias !== this.state.SessionName.alias && sessItem.alias.toLowerCase().trim() === e.target.value.toLowerCase().trim()) {
        duplicate = true;
      }
    });

    if (duplicate) {
      if (e.target.value.length <= 25) {
        this.setState({ SessionNameTxt: e.target.value, DupAvailable: 'Session name already exists. Please choose a different name.' });
      }
    } else {
      if (e.target.value.length <= 25) {
        this.setState({ SessionNameTxt: e.target.value, DupAvailable: '' });
      }
    }
    // this.setState({ SessionNameTxt: e.target.value });
  }

  ToggleMinimize() {
    this.setState({ ToggleMinimize: !this.state.ToggleMinimize });
  }

  RightNavLayer() {
    if (this.state.ShowRightLayer) {
      this.setState({ ShowRightLayer: false })
    } else {
      this.setState({ ShowRightLayer: true })
    }
  }

  NextBtnVisible() {
    var currentPage;
    this.state.RouteObj.map((route, id) => {
      if (window.location.pathname.indexOf(route.path) > 0)
        currentPage = id;
    });
    if (currentPage !== undefined) {
      if (this.state.RouteObj.length - 1 !== currentPage) {
        if (this.state.RouteObj[currentPage + 1].isenabled === true) {
          NextBtnVisible = true;
        } else {
          NextBtnVisible = false;
        }
      }
      else { NextBtnVisible = false; }
    }
    else {
      NextBtnVisible = false;
    }
    return NextBtnVisible;
  }

  onSaveWorkloadIconClick() {
    if (this.props.GlobalErr != '' && this.props.GlobalErr.isError) {
      this.setState({ ErrorPopup: true, ErrorPopupMsg: this.props.GlobalErr.errorMsg });
    } else {
      // if(this.props.activeSession.alias.indexOf('Default Session') === 0){
      this.props.OpenedSaveWorkload(true)
      this.setState({ showSaveWorkload: true, SessionNameTxt: this.props.activeSession.alias });
      // }else{
      // this.SaveWorkload();
      // }
    }
  }

  SaveWorkloadSubmit() {
    // this.state.SessionName = this.props.activeSession;
    // this.Submit_Update_Session();
    this.props.OpenedSaveWorkload(false)

    this.props.onUpdateActiveSession(this.props.sizerWorkLoad);
    if (this.state.SessionNameTxt !== null && this.state.SessionNameTxt.trim() !== '') {
      var initialCheck = false;
      this.SaveWorkload(initialCheck);
    }
  }

  SaveWorkload(overrideParam) {
    var workload = { "WorkLoad": {} };
    this.props.activeSession.workload = this.props.sizerWorkLoad;
    if (said == "CS750VirtSizer" ||  said === 'SynergySizer') {
      workload.WorkLoad = this.props.activeSession.workload.Workload;
    }
    else {
      workload.WorkLoad = this.props.activeSession.workload;
    }

    var userId = this.props.UserID;

    if (userId === undefined) {
      userId = 'TestUser@test.com';
    }
    var sessionObject = {
      "Workload": workload,
      "SessionID": this.props.activeSession.id,
      //"UserId": "Madhukar",
      "UserId": userId,
      //"SizerType": sizerType,
      "SizerId": said,
      "Alias": this.state.SessionNameTxt,
      "Override": overrideParam
    }
    // var sessionObject = { "SessionID": this.props.activeSession.id };
    this.props.onSaveWorkload(sessionObject);
  }

  OverrideMsgYesClick() {
    this.SaveWorkload(true);
    this.state.showSaveWorkload = false;
    this.setState({ showDupWLPopup: false });
  }

  OverrideMsgNoClick() {
    this.state.showSaveWorkload = true;
    this.setState({ showDupWLPopup: false });
    this.props.onDisableconflicts();

  }

  sizeFailedClose() {
    this.setState({ sizingFailed: false, sizingFailedMsg: '' });
    if (this.props.sizeError !== undefined && this.props.sizeError !== '')
      this.props.sizeError.isFailed = false;
  }

  LoadWorkloadPopupClick() {
    if (said === 'SAP') {
      // this.props.onNewSession(this.props.workloadTemplate);
      this.props.onUpdateDefaultSession(this.props.DefaultInputs);
    }
    this.setState({ LoadItemTitle: 'All', LoadPopupScr: true });
  }

  getNewRoute(str) {
    this.closePopUps();
    this.props.history.push(str);
  }

  closePopUps() {
    this.setState({
      LoadItemTitle: '', LoadPopupScr: false
    })
  }

  render() {

    let ToogleBtn;
    var LayerRight;
    var showDelSession;
    var showAddSession;
    var showSaveWorkload;
    var showDupWLPopupContent;
    // if(this.props.GlobalErr !='' && this.props.GlobalErr.isError){

    // }

    let SizingButton = '';
    let buttonId = this.props.SSETid !== undefined ? 'sizeWorkloadBtn' : '';
    //var rslt = this.props.SSETid !== undefined ? buttonId = 'sizeWorkloadBtn' : '';
    // if(!this.props.isSizeEnabled){
    if (!this.props.activeSession.isSizeEnabled) {
      SizingButton = <Button primary={true} label='Finish' icon={<Magic />} style={{ padding: '6px 6px', width: '100%' }} />;
    } else {
      SizingButton = <Button primary={true} label='Finish' id={buttonId} onClick={this.onFinish} icon={<Magic />} style={{ padding: '6px 6px', width: '100%' }} />;
    }

    let RouteWithSubRoutes = (route) => (
      <Route path={route.path} render={props => (
        // pass the sub-routes down to keep nesting
        <route.component {...props} routes={route.routes} />
      )} />
    )

    let links = this.state.RouteObj.map((route, id) => {

      if (window.location.pathname.match(route.path)) {
        activeLinkClass = 'active';
      } else {
        activeLinkClass = '';
      }
      let displa = "Visible"


      return <Box key={id} direction="row" margin="none" pad="none" style={{ display: displa }}>
        <Box id={id} className={activeLinkClass} style={{ color: 'transparent', width: '4%' }}>a</Box>
        <li id={id} style={{ width: '96%' }}>
          <Anchor id={route.label} label={route.label} onClick={this.onLeftNavSelection.bind(this)} />
        </li>
      </Box>
    });
    let activeLinkClass = '';

    if (window.location.pathname.match('Build/SolnAlternative')) {
      activeLinkClass = 'active';
    } else {
      activeLinkClass = '';
    }

    //let disable = '';
    // var modified = this.isModified();

    // if(this.props.activeSession.isSizeEnabled ||  window.location.pathname.match("/SolnAlternative")  || (!this.props.activeSession.isSizeEnabled && !modified))
    // {
    //   disable = false;
    // }
    // else {
    //   disable = true;
    // }

    let solSummaryLink = <Box key={'Summary'} direction="row" margin="none" pad="none">
     <Box id={'Summary'} className={activeLinkClass} style={{ color: 'transparent', width: '4%' }}>a</Box>
     <li id={'Summary'} style={{ width: '96%' }}>
       <Anchor id={'Summary'} label={'Solution Summary'} onClick={this.onSolutionSummaryclick.bind(this)} />
     </li>
    </Box>

    //var temp = window.location.pathname.match("/SolnAlternative") || fromsoln ? links.push(solSummaryLink) : null

    if(window.location.pathname.match("/SolnAlternative") || fromsoln)
    {
      links.push(solSummaryLink);
    }

    let SolnLostPopup = '';
    if (this.state.ShowSolnLostMsg) {
      SolnLostPopup = <Layer>
        <Box margin='none' pad='none' size='medium' >
          <Box direction="row" colorIndex='neutral-1' margin="none" style={{ padding: '12px 12px 0px 12px' }} separator="bottom">
            <Box direction="row" margin="none" pad={{ between: 'small' }} align='start' style={{ width: '96%' }}>
              <WarningIcon size='small' colorIndex='warning' />
              <Heading tag="h4" strong={false} >Please Confirm</Heading>
            </Box>
            <Box direction="row" margin="none" pad="none" align='start' alignContent="start" onClick={this.onSolnLostPopupClose} >
              <CloseIcon size='small' colorIndex="light-2" className="CloseIconStyle" />
            </Box>
          </Box>
          <Box margin="none" pad="small">
            <Heading tag='h6' strong={false} margin='none'>
              Solution will be lost, are you sure you want to continue ?
                                         </Heading>
          </Box>
          <Box direction='row' justify='end' margin='none' pad='small'>
            <Button label='Yes' className="SessionOutBtns" onClick={() => this.onSolnLostPopupYes(this.state.NavSelection)} />
            <Button label='No' className="SessionOutBtns" critical={true} onClick={this.onSolnLostPopupClose} />
          </Box>
        </Box>
      </Layer>
    }
    var toast = '';
    if (this.props.toastNotification.isEnabled) {


      toast = <Layer closer={false} overlayClose={true} >
        <Box margin="none" pad="none" size='medium'>
          <Box direction="row" colorIndex='neutral-1' margin="none" pad="small" separator="bottom">
            <Box direction="row" margin="none" pad={{ between: 'small' }} align='start' style={{ width: '96%' }}>
              <CircleInformation colorIndex='accent-1-t' size='small' />
              <Heading tag="h4" strong={false} style={{ marginBottom: '0px' }}>Information</Heading>
            </Box>
            <Box direction="row" margin="none" pad="none" align='start' alignContent="start"
              onClick={this.props.onCloseToast} >
              <CloseIcon size='small' colorIndex='light-2' className="CloseIconStyle" />
            </Box>
          </Box>
          <Box direction="row" margin="small" pad={{ between: 'small' }} >
            {this.props.toastNotification.isError ? undefined :
              <Status value='ok' style={{ margin: '12px 12px 0px 0px' }} />
            }
            <Paragraph margin="small" >{this.props.toastNotification.msg}</Paragraph>
          </Box>
        </Box>
      </Layer>

      // <Box pad="small" justify="between" direction="row" colorIndex="light-2" >
      //              <Box pad={{between:'small'}} justify="between" direction="row" >
      //                 <Status value='ok' />
      //                 <Heading tag='h5' strong={false} margin='none'> {this.props.toastNotification.msg} </Heading>
      //              </Box>
      //              <Box pad="none" direction="row" onClick={this.props.onCloseToast} ><FormClose size="small"/></Box>
      //           </Box>
      // toast =  <Toast status='ok' onClose={ this.props.onCloseToast} style={{zIndex: '100007'}}> {this.props.toastNotification.msg} </Toast>
    } else {
      toast = '';
    }

    let RedirectPopup = '';
    if (this.state.RedirectPopup) {
      RedirectPopup = <Layer closer={false} overlayClose={true} >
        <Box margin="none" pad="none" size='medium' >
          <Box direction="row" colorIndex='neutral-1' margin="none" pad="small" separator="bottom">
            <Box direction="row" margin="none" pad={{ between: 'small' }} align='start' style={{ width: '96%' }}>
              <WarningIcon colorIndex='critical' size='small' />
              <Heading tag="h4" strong={false} style={{ marginBottom: '0px' }}>Error</Heading>
            </Box>
            <Box direction="row" margin="none" pad="none" align='start' alignContent="start"
              onClick={() => {
                this.props.onRedirectPage(true, this.state.RouteObj[1]['path']);
                // this.props.history.push(this.state.RouteObj[1]['path']);
                this.setState({ RedirectPopup: false, RedirectMsg: '' })
              }
              } >
              <CloseIcon size='small' colorIndex='light-2' className="CloseIconStyle" />
            </Box>
          </Box>
          <Box direction="row" margin="small" pad={{ between: 'small' }} >
            <Paragraph margin="small" >{this.state.RedirectMsg}</Paragraph>
          </Box>
        </Box>
      </Layer>
    }

    let sizingFailed = '';
    if (this.state.sizingFailed) {
      sizingFailed = <Layer closer={false} overlayClose={true} >
        <Box margin="none" pad="none" size='medium'>
          <Box direction="row" colorIndex='neutral-1' margin="none" pad="small" separator="bottom">
            <Box direction="row" margin="none" pad={{ between: 'small' }} align='start' style={{ width: '96%' }}>
              <WarningIcon colorIndex='critical' size='small' />
              <Heading tag="h4" strong={false} style={{ marginBottom: '0px' }}>Alert</Heading>
            </Box>
            <Box direction="row" margin="none" pad="none" align='start' alignContent="start" onClick={this.sizeFailedClose} >
              <CloseIcon size='small' colorIndex='light-2' className="CloseIconStyle" />
            </Box>
          </Box>
          <Box direction="row" margin="small" pad={{ between: 'small' }} >
            <Paragraph margin="small" >{this.state.sizingFailedMsg}</Paragraph>
          </Box>
        </Box>
      </Layer>
    }

    let ErrorPopup = '';
    if (this.state.ErrorPopup) {
      ErrorPopup = <Layer closer={false} overlayClose={true} >
        <Box margin="none" pad="none" size='medium'>
          <Box direction="row" colorIndex='neutral-1' margin="none" pad="small" separator="bottom">
            <Box direction="row" margin="none" pad={{ between: 'small' }} align='start' style={{ width: '96%' }}>
              <WarningIcon colorIndex='critical' size='small' />
              <Heading tag="h4" strong={false} style={{ marginBottom: '0px' }}>Error</Heading>
            </Box>
            <Box direction="row" margin="none" pad="none" align='start' alignContent="start" onClick={() => this.setState({ ErrorPopup: false, ErrorPopupMsg: '' })} >
              <CloseIcon size='small' colorIndex='light-2' className="CloseIconStyle" />
            </Box>
          </Box>
          <Box direction="row" margin="small" pad={{ between: 'small' }} >
            <Paragraph margin="small" >{this.state.ErrorPopupMsg}</Paragraph>
          </Box>
        </Box>
      </Layer>
    }

    if (this.state.ToggleMinimize) {
      ToogleBtn = <Button data-tip="Expand" icon={<MenuIcon colorIndex="accent-3" size="small" />} onClick={this.ToggleMinimize} />;
    } else {
      ToogleBtn = <Button data-tip="Minimize" icon={<ContractIcon colorIndex="accent-3" size="small" />} onClick={this.ToggleMinimize} />;
    }

    if (this.state.ShowRightLayer) {
      LayerRight = <SolutionPreview onClose={this.RightNavLayer} />
      //       LayerRight = <Box colorIndex="light-2" direction="row" align='start' pad='none' separator="left"
      //                         style={{height:'100%', width:'300px', overflowY: 'auto',
      //                         position:'absolute',right:'0px',top:'0px',zIndex:3}}>
      //              <Animate enter={{"animation": "slide-left", "duration": 200, "delay": 0}}
      //                       leave={{"animation": "slide-left", "duration": 200, "delay": 0}}
      //                       keep={true} style={{width:'100%'}} >
      //                   <Box direction='row'>

      //                    <List style={{width:'100%'}}>
      //                      <Heading tag="h4" align="center" margin="none" strong={true} style={{backgroundColor:'#28ab8c',padding:'4px',color:'#fff'}}>Solution Preview</Heading>
      // {/*this.props.DefaultInputs.SolutionPreview.PageCaption*/}
      //                      <ListItem justify='between' direction="column" separator='horizontal'>
      //                         <span> Solution Profile Recommended </span>
      //                         <span style={{width:'100%',textAlign:'center'}} className='secondary'> (Role:Mailbox(log and database isolated) server -Site1 -No DAG) </span>
      //                       </ListItem>

      //                       <ListItem justify='between' direction="column" separator='horizontal'>
      //                         <span> Server Type </span>
      //                         <span className='secondary'> Proliant </span>
      //                       </ListItem>
      //                       <ListItem justify='between' direction="column" separator='horizontal'>
      //                         <span> ServerPlatform  </span>
      //                         <span className='secondary'> Tower </span>
      //                       </ListItem>
      //                        <ListItem justify='between' direction="column" separator='horizontal'>
      //                         <span> Processor Vendor </span>
      //                         <span className='secondary' > Intel </span>
      //                       </ListItem>
      //                        <ListItem justify='between' direction="column" separator='horizontal'>
      //                         <span> Server </span>
      //                         <span className='secondary'> Proliant ML350 Gen9(CTO) </span>
      //                       </ListItem>
      //                     </List>
      //                  </Box>
      //              </Animate>
      //       </Box>
    } else {
      LayerRight = ""
    }

    if (window.location.pathname.match("/SolnAlternative")) {
      this.state.showFooter = NextBtnVisible = false;
    } else if (!window.location.pathname.match("/Home")) {
      NextBtnVisible = this.NextBtnVisible();
      this.state.showFooter = true;
    }

    if ((this.props.OverrideMsg.isEnabled && this.state.showDupWLPopup) || this.state.showRedirectConfirm) {
      let messageToDisplay='';
      let yesMethod='';
      let noMethod='';

      if(this.state.showRedirectConfirm)
      {
        messageToDisplay = "All your changes will be lost if you select yes to continue. Would you like to continue?";
        yesMethod = this.goBackToSSETyes.bind(this);
        noMethod = this.goBackToSSETno.bind(this);
      }
      else{
        messageToDisplay = this.props.OverrideMsg.msg;
        yesMethod = this.OverrideMsgYesClick;
        noMethod = this.OverrideMsgNoClick;
      }

      showDupWLPopupContent =
        <Layer>
          <Box margin='none' pad='none' size='medium' >
            <Box direction="row" colorIndex='neutral-1' margin="none" style={{ padding: '12px 12px 0px 12px' }} separator="bottom">
              <Box direction="row" margin="none" pad={{ between: 'small' }} align='start' style={{ width: '96%' }}>
                <WarningIcon size='small' colorIndex='warning' />
                <Heading tag="h4" strong={false} >Please Confirm</Heading>
              </Box>
            </Box>
            <Box margin="none" pad="small">
              <Heading tag='h6' strong={false} margin='none'>
                {messageToDisplay}
              </Heading>
            </Box>
            <Box direction='row' justify='end' margin='none' pad='small'>
              <Button id='backToSSETyes' label='Yes' className="SessionOutBtns" onClick={yesMethod} />
              <Button label='No' className="SessionOutBtns" critical={true} onClick={noMethod} />
            </Box>
          </Box>
        </Layer>
    } else {
      showDupWLPopupContent = ""
    }

    if (this.state.showSaveWorkload) {
      showSaveWorkload = <Layer>
        <Box margin='none' pad='none' size='medium' justify='between' >
          <Box direction="row" colorIndex='neutral-1' margin="none" style={{ padding: '12px 12px 0px 12px' }} separator="bottom">
            <Box direction="row" margin="none" pad={{ between: 'small' }} align='start' style={{ width: '96%' }}>
              <Heading tag="h4" strong={false} >Please name your workload:</Heading>
            </Box>
            <Box direction="row" margin="none" pad="none" align='start' alignContent="start" onClick={this.CloseDelSession} >
              <CloseIcon size='small' colorIndex='light-2' className="CloseIconStyle" />
            </Box>
          </Box>
         { /* <Box direction='row' pad='small'>
            <RadioButton id='choice1-1'
              name='choice1-1'
              label='Save in Disk'
              checked={this.state.bigdataChecked}
              onChange={() => { this.setState({ bluedataChecked: false, bigdataChecked: true }) } }
              />
            <RadioButton id='choice1-2'
              name='choice1-2'
              label='Save in Server'
              checked={this.state.bluedataChecked}
              onChange={() => { this.setState({ bluedataChecked: true, bigdataChecked: false }) } }
              />
          </Box>
         <Box direction='row'>
          <Label> Save in</Label> <Select placeHolder='None' style={{ marginBottom: '1px' }} value={"Disk"} options={["Disk","Server"]}  />
          </Box>*/}
          <Box direction="row" margin="none" pad="small" justify="start" style={{ width: '100%' }}>
            <TextInput onPaste={this._handleOnPaste} value={this.state.SessionNameTxt} style={{ width: '80%' }}
              placeHolder='Session Name'
              onDOMChange={this.SessionTxtChange} />
            {this.state.SessionNameTxt === '' || this.state.SessionNameTxt.trim() === '' ?
              <Button primary={true} icon={<FormNextLink size='small' />} />
              :
              <Button primary={true} icon={<FormNextLink size='small' />}
                onClick={this.SaveWorkloadSubmit} />
            }
          </Box>
        </Box>
      </Layer>
    } else {
      showSaveWorkload = ""
    }

    var tempText = '';
    var tempMethod = '';

    if (this.state.showUpdateSession) {
      tempText = 'Update Session';
      tempMethod = this.Submit_Update_Session;
    }

    if (this.state.showAddSession) {
      tempText = 'Add Your Session';
      tempMethod = this.Submit_Add_Session;
    }

    if (this.state.showAddSession || this.state.showUpdateSession) {
      showAddSession = <Layer>
        <Box margin='none' pad='none' size='medium' justify='between' >
          <Box direction="row" colorIndex='neutral-1' margin="none" style={{ padding: '12px 12px 0px 12px' }} separator="bottom">
            <Box direction="row" margin="none" pad={{ between: 'small' }} align='start' style={{ width: '96%' }}>
              <Heading tag="h4" strong={false} >{tempText}</Heading>
            </Box>
            <Box direction="row" margin="none" pad="none" align='start' alignContent="start" onClick={this.CloseDelSession} >
              <CloseIcon size='small' colorIndex='light-2' className="CloseIconStyle" />
            </Box>
          </Box>
          {/* {this.state.showAddSession && said === 'EPAvNext' ? <Box direction='row' pad='small'>
            <RadioButton id='choice1-1'
              name='choice1-1'
              label='Big Data'
              checked={this.state.bigdataChecked}
              onChange={() => { this.setState({ bluedataChecked: false, bigdataChecked: true }) } }
              />
            <RadioButton id='choice1-2'
              name='choice1-2'
              label='HPE CP'
              checked={this.state.bluedataChecked}
              onChange={() => { this.setState({ bluedataChecked: true, bigdataChecked: false }) } }
              />
          </Box>
            : null} */}
          <Box direction="row" margin="none" pad="small" justify="start" style={{ width: '100%' }} >
            <TextInput onPaste={this._handleOnPaste} value={this.state.SessionNameTxt} style={{ width: '80%' }}
              placeHolder='Session Name'
              onDOMChange={this.SessionTxtChange} />
            {this.state.SessionNameTxt === '' || this.state.SessionNameTxt.trim() === '' ||
              this.state.DupAvailable !== '' ?
              <Button primary={true} icon={<FormNextLink size='small' />} />
              :
              <Button primary={true} icon={<FormNextLink size='small' />}
                onClick={tempMethod} />
            }
          </Box>
          {this.state.DupAvailable !== '' ?
            <Box margin="none" pad='none' align='start' >
              <Heading tag="h5" strong={false} className='SessionExtPopup' >{this.state.DupAvailable}</Heading>
            </Box>
            :
            ''
          }
        </Box>
      </Layer>
    } else {
      showAddSession = ""
    }

    if (this.state.showDelSession) {
      showDelSession = <Layer>
        <Box margin='none' pad='none' size='medium' >
          <Box direction="row" colorIndex="neutral-1" margin="none" style={{ padding: '12px 12px 0px 12px' }} separator="bottom">
            <Box direction="row" margin="none" pad={{ between: 'small' }} align='start' style={{ width: '96%' }}>
              <WarningIcon size='small' colorIndex='warning' />
              <Heading tag="h4" strong={false} >Please Confirm</Heading>
            </Box>
            <Box direction="row" margin="none" pad="none" align='start' alignContent="start" onClick={this.CloseDelSession} >
              <CloseIcon size='small' colorIndex='light-2' className="CloseIconStyle" />
            </Box>
          </Box>
          <Box margin="none" pad="small">
            <Heading tag='h6' strong={false} margin='none'>
              Are you sure you want to delete the selected session:
                                         </Heading>
            <Heading tag='h6' strong={true} margin='none'>
              {this.state.DelSession.alias}
            </Heading>
          </Box>
          <Box direction='row' justify='end' margin='none' pad='small'>
            <Button label='Yes' className="SessionOutBtns" onClick={() => this.Submit_Delete_Session(this.state.DelSession.id)} />
            <Button label='No' className="SessionOutBtns" critical={true} onClick={this.CloseDelSession} />
          </Box>
        </Box>
      </Layer>
    } else {
      showDelSession = ""
    }

    var sessionsMenu = "";

    if (this.props.allSessions.length > 0) {

      var s = this.props.allSessions.map((val) => {
        return (

          <TableRow key={val.id}>
            <td> <Anchor pad='none' margin='small' className="UserSelectionAnchor" style={{ margin: '0px 0px', fontWeight: '500' }}
              onClick={() => this.Submit_Change_Session(val.id)}>
              {val.alias}
            </Anchor></td>
            <td>  <Button primary={false} plain={true} onClick={() => this.setState({ SessionName: val, SessionNameTxt: val.alias, showUpdateSession: true, showAddSession: false })}
              icon={<FormEdit size="small" colorIndex='#ff9374' />} /> </td>
            <td>   <Button primary={false} plain={true} onClick={() => this.ShowDelSession(val)}
              // onClick ={ ()=>this.props.onDeleteSession(val.id) }     
              icon={<TrashIcon size="small" colorIndex='#ff9374' />} /> </td>
          </TableRow>


        )
      });

      //  var s = this.props.allSessions.map((val) => {
      //     return(

      //           <TableRow key={val.id} >
      //             <td>
      //               <Box direction='row' >
      //                    <Anchor pad='none' margin='none' className="UserSelectionAnchor"style={{margin:'12px 0px', fontWeight: '500'}}
      //                            onClick={() => this.Submit_Change_Session(val.id) }>
      //                            {val.alias}
      //                    </Anchor>
      //                    <Button primary={false} plain={true} onClick = { () => this.setState({ SessionName: val, SessionNameTxt: val.alias, showUpdateSession: true, showAddSession: false }) }
      //                            icon={<FormEdit size="small" colorIndex='#ff9374' />}  />
      //                    <Button primary={false} plain={true} onClick ={ () => this.ShowDelSession(val) }
      //                            // onClick ={ ()=>this.props.onDeleteSession(val.id) }
      //                            icon={<TrashIcon size="small" colorIndex='#ff9374' />}  />
      //               </Box>
      //                </td>
      //          </TableRow> 
      //     )
      // });
    }

    sessionsMenu = <Menu className="SessionsList"responsive={true} closeOnClick={true} size='medium' margin='none'
      icon={<User size="small" colorIndex='accent-3' />}
      label={this.props.activeSession.alias} >
      {this.props.SSETid === undefined ?
        <Table className="UserSelectDropdownItems">
          <tbody>
            <TableRow>
              <Box direction='row'>
                <Anchor className="UserSelectionAnchor" style={{ margin: '0px 0px', fontWeight: '500' }} onClick={this.AddUserClick}>Add New</Anchor>
                <Button primary={false} plain={true} onClick={this.AddUserClick}
                  icon={<UserAdd size="small" colorIndex='brand' />} />
              </Box>
            </TableRow>
            {s}
          </tbody>
        </Table> : ''}

    </Menu>

    let SolutionPreviewContent = '';

    //if(this.props.DefaultInputs["@name"] === "SAP HANA Sizing Tool"){
    if (said === "CS750VirtSizer" ||  said === 'SynergySizer' || said === 'EPA') {
      SolutionPreviewContent = '';
    } else {
      if (!window.location.pathname.match("/SolnAlternative")) {
        SolutionPreviewContent = <Button primary={true} label='Solution Preview' onClick={this.RightNavLayer} style={{ padding: '6px 6px', width: '100%', marginBottom: '10px' }} />;
      }
    }
      var stylefooter=''
      if(said === 'EPAvNext'){
         stylefooter='NextPrevSecVNext'
        //  { position: 'fixed', bottom: '0px', height: '6%', width: '100%', backgroundColor: 'rgba(66, 85, 99, 0.82)',zIndex: '1000000' }
      }else{
         stylefooter='NextPrevSec'
        //  { position: 'fixed', bottom: '0px', height: '6%', width: '100%', backgroundColor: 'rgba(66, 85, 99, 0.82)'}
      }
      if(said === 'SAPHANA'){
        if(this.props.sizerWorkLoad.UserInputs.Environments.WorkloadType === 'TDI'){
        this.state.TitleofSizer = 'HPE Sizing Tool for SAP TDI';
      } else{
        this.state.TitleofSizer = title;
      }
    }

    const layer = (
      <Layer className='LoadPopupLayer'>
        <LoadFiles title={this.state.LoadItemTitle}
          // history={history}
          redirectTo={this.getNewRoute}
          onClose={this.closePopUps} />
      </Layer>
    );

    var layerelement;
    if(this.state.LoadPopupScr)
    {
      layerelement = layer;
    }
    let featureFlag = window.sessionStorage.getItem("featureFlag");
    return (
      <Box>
        {toast}
    {/* <Box direction='row' className="" margin="none" pad="none" justify="end" separator="bottom" style={this.state.PositionFixedState}>*/}
        <Box direction='row' className="" margin="none" pad="none" justify="end" separator="bottom" style={{backgroundColor:'#fff'}}>
          <Box direction='row' size='small' align="start">
            <ReactTooltip place="right" multiline={true} />
            {ToogleBtn}
            {sizingFailed}
            {ErrorPopup}
            {RedirectPopup}
            {SolnLostPopup}
            <Button data-tip="Home" icon={<Home size="small" colorIndex="accent-3" />} onClick={this.props.SSETid === undefined ? this.goHome : ''} />

          </Box>
          <Box basis="xxlarge">
            <Heading align='start' tag='h4' strong={true} style={{ fontSize: '23px', margin: 'auto 0%', paddingLeft: '6px', color: '#01a982', borderLeft: '1px solid #bdbcbc' }}>{this.state.TitleofSizer} </Heading>
            {showDelSession}
            {showAddSession}
            {showSaveWorkload}
            {showDupWLPopupContent}
            {layerelement}
          </Box>
          <Box align="center" basis="large" direction="row" margin="none" pad={{ horizontal: "large", between: 'small' }} >
            {this.props.sessionsData!==undefined && !this.props.sessionsData.reviewed && featureFlag === "True" && this.props.SSETid && (said === 'SAP' || said === 'SAPHANA' || said === 'EPAvNext') ?
              <Box direction='row' margin='none' pad={{ between: 'small' }} style={{ width: '175px' }}>
                <Button primary={false} plain={true} icon={<DocumentConfig size="small" colorIndex='accent-3' />} label='Load Workload' onClick={this.LoadWorkloadPopupClick} className="ReverseSavewrkloadbtn" />
              </Box> 
              : null
            }
            {this.state.showFooter ?
              <Box>
                {!this.props.SSETid ?
                  <Box direction='row' margin='none' pad={{ between: 'small' }} style={{ width: '175px' }}>
                    <Button primary={false} plain={true} icon={<SaveIcon size="small" colorIndex='accent-3' />} label='Save Workload' onClick={this.onSaveWorkloadIconClick} className="ReverseSavewrkloadbtn" />
                  </Box> :
                  null
                }
              </Box>
              : null}
            {sessionsMenu}
          </Box>
        </Box>
        <Box direction='row'>
          <Split flex='right' style={{ width: '100%', overflow: "hidden" }} pad="small" className="LeftSec" showOnResponsive='both'>
            {!this.state.ToggleMinimize ?
              <Animate enter={{ "animation": "slide-right", "duration": 500, "delay": 0, "height": '100%' }} leave={{ "animation": "slide-right", "duration": 500, "delay": 0, "height": '100%' }} style={{ height: '100%' }} keep={true}>
                <Box justify='between' style={{ width: '100%', height: '100%' }} basis="large" className="MenuToggle" align='center' pad='none' margin='none'>
                  <Box justify='between' style={{ width: '100%', height: '100%' }}>
                    <Box style={{ width: '100%' }}>
                      <ul className="LeftNav">
                        {links}
                      </ul>
                    </Box>
                    <Box>
                      {SolutionPreviewContent}
                    </Box>
                  </Box>
                </Box>  </Animate> : null}
            <Box direction="row" className="RightSec" justify='start' style={{ width: '100%', height: '100%' }} align='center' pad='none'>
              <Box direction="row" style={{ height: '100%', width: '100%' }}>
                <Box className="Togglebtncls">

                </Box>
                <Switch>
                  {this.state.RouteObj.map((route, i) => (
                    <RouteWithSubRoutes key={i} {...route} />
                  ))}
                  <Route exact path='/Build/SolnAlternative' component={SolnAlternative} />
                </Switch>
              </Box>
              {LayerRight}
            </Box>
          </Split>
        </Box>
        {this.state.ShowProgressBar ?
          <Box direction="column" margin="none" pad="none" style={{ width: '100%', position: 'fixed', bottom: '5.8%' }} >
            <Box margin="none" pad="none" align="end" >
              <Heading tag="h3"> 100%</Heading>
            </Box>
            <Box className="ProgressBar" style={{ width: '100%', backgroundColor: 'rgba(98, 113, 125, 0.57)', bottom: '6%' }}>
              <Box margin="none" pad="none" style={{ width: '20%' }} className="ProgressBarAfter"></Box>
            </Box>
          </Box> : null}
        {this.state.showFooter ?
          <Box className={stylefooter} direction="row" justify="between" margin="none" pad="none">
            <Box direction="row" basis="small" />
            <Box direction="row" justify="center" basis="xxlarge" >
              {/* window.location.pathname.match("/ContactInfo") ? */}
              {window.location.pathname.match(this.state.RouteObj[0]['path']) ?
                <Box align="center" direction="row" className="NextPrevIconDisabled" alignContent="center" style={{ justifyContent: 'center', width: '10%' }} separator="all">
                  <CaretPrevious size="small" colorIndex='brand' /><Box style={{ color: 'darkgray' }} pad='none' margin='none'>Previous</Box>
                </Box>
                :
                <Box direction="row" align="center" className="NextPrevIcon" alignContent="center" onClick={this.onPrevClick} style={{ justifyContent: 'center', backgroundColor: '#01a982', width: '10%' }} separator="all">
                  <CaretPrevious size="small" colorIndex='brand' /><Box pad='none' margin='none' style={{ color: 'white' }}>Previous</Box>
                </Box>
              }
              {NextBtnVisible ?
                <Box direction="row" align="center" className="NextPrevIcon" alignContent="center" onClick={this.onNextClick} style={{ justifyContent: 'center', backgroundColor: '#01a982', width: '10%', marginLeft: '2px' }} separator="all">
                  <Box pad='none' margin='none' style={{ backgroundColor: '#01a982', color: 'white' }}>Next</Box><CaretNext size="small" colorIndex='brand' />
                </Box>
                :
                <Box direction="row" align="center" className="NextPrevIconDisabled" alignContent="center" style={{ justifyContent: 'center', width: '10%', marginLeft: '2px' }} separator="all">
                  <Box pad='none' margin='none' style={{ color: 'darkgray' }}> Next </Box><CaretNext size="small" colorIndex='brand' />
                </Box>
              }
            </Box>
            {!this.props.SSETid ?
              <Box direction='row' style={{ color: '#ffff', justifyContent: "center", position: 'absolute', right: '16%', padding: '8px 0px' }}>
                <div style={{ color: "white" }}>Click here to generate the Solution </div><FormArrow style={{ stroke: '#ff8d6d' }} />
              </Box> :
              <Button primary={true} label='Cancel' id={buttonId} onClick={this.goBackToSSET} icon={<Revert />} style={{  width: '200px', color:'white', marginRight:'10px' }} />
            }
            <Box direction="row" basis="small" className="NextPrevIcon" style ={{ flexBasis: '222px' }}>
              {SizingButton}
            </Box>
          </Box>
          : <CustomFooter />}
      </Box>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    allSessions: state.sessions.sessions,
    activeSession: state.sessions.activeSession,
    treeView: state.sessions.activeSession.treeView,
    TitleCaption: state.sessions.sessionDefaults.inputs.Sizers,
    //DefaultInputs: state.sessions.sessionDefaults.inputs.Sizers.Sizer,
    GlobalErr: state.sessions.activeSession.globalError,
    isSizeEnabled: state.sessions.activeSession.isSizeEnabled,
    country: state.sessions.Country,
    OverrideMsg: state.sessions.overrideMsg,
    toastNotification: state.sessions.notificationMsg,
    Redirect: state.sessions.redirect,
    UserID: state.auth.userData.hpclname,
    UserName: state.auth.userData.username,
    sizerWorkLoad: state.sizerWorkload.workload,
    workloadTemplate: state.sessions.sessionDefaults.workload,
    validation: state.sizerWorkload.validation,
    sizeError: state.sessions.activeSession.sizingFailed,
    blueDataworkloadTemplate: state.sessions.sessionDefaults.blueDataWorkload,
    tdiWorkloadTemplate: state.sessions.sessionDefaults.tdiWorkload,
    indexes: state.sizerWorkload.Indexes,
    SSETid: state.sessions.SSETid,
    SSETUrl: state.sessions.SSETUrl,
    guiState: state.sizerWorkload.guiState,
    sessionsData: state.sessions.ssetConfigurations,
    DefaultInputs: state.sessions.sessionDefaults.inputs,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {

    onShowLoading:()=>{
      const message = 'Please Wait..'
      dispatch(showLoading(message))
    },
    onAddSession: (id, name) => {

      dispatch(addSession(id, name));
    },
    onChangeSession: (id) => {
      dispatch(changeSession(id));
    },
    onDeleteSession: (id) => {
      dispatch(deleteSession(id));
    },
    onUpdateSession: (session) => {
      dispatch(updateSession(session))
    },
    updateError: (errorMsg) => {
      dispatch(errorValidataion(errorMsg));
    },
    onGetSolution: (workload) => {
      dispatch(getSolution(workload))
    },
    onGetAdvancedSolution: (workload) => {
      dispatch(getAdvancedSolution(workload))
    },
    onSaveCurrentSession: () => {
      dispatch(SaveCurrentSession());
    },
    onSaveWorkload: (sessionID) => {
      dispatch(saveWorkload(sessionID));
    },
    onDisableconflicts: () => {
      dispatch({ type: 'DISMISS_CONFLICTS' })
    },
    onCloseToast: () => {
      dispatch({ type: 'DISMISS_TOAST' });
    },
    OnToggleSizeButton: (value) => {
      dispatch(toggleSizeButton(value));
    },
    onRedirectPage: (isTrue, path) => {
      dispatch(redirectPage(isTrue, path));
    },
    onNewSession: (workload) => {
      dispatch({ type: 'UPDATE_SIZER_WORKLOAD', payload: workload })
    },
    onUpdateActiveSession: (workload) => {
      dispatch({ type: 'UPDATE_Active_WORKLOAD', payload: workload })
    },
    onValidateWorkload: (url, workload) => {
      dispatch(validateWorkload(url, workload));
    },
    OpenedSaveWorkload: (value) => {
      dispatch(saveworkloadopened(value));
    },
    ClearCompareData: () => {
      dispatch({type: 'CLEAR_COMPARE_DATA'});
    },
    onUpdateDefaultSession: (inputs) => {
      dispatch({ type: 'UPDATE_SESSION_DEFAULTS', payload: inputs })
    },
    
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Build);



// WEBPACK FOOTER //
// ./src/SizingEngineUI/SizingEngineCommonScreens/Build.js